import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { actionResetGetConfigPtMonMedidor } from '../get-monitoramento/slices'
import { deleteConfigPtMonMedidor } from './services'

const initialState: any = {
  status: "",
  data: []
}

export const actionDeleteConfigPtMonMedidor: any = createAsyncThunk<any, any>(
  "ACTION_DELETE_CONFIG_PT_MON_MEDIDOR",
  async (_, { getState }: any) => {
    const {
      modulosByCentral: {
        entradaSelected: {
          modulo: {
            idCentral,
            adrModulo,
          },
          entrada
        }
      },
    } = getState()

      return deleteConfigPtMonMedidor({
      idCentral,
      adrModulo,
      idEntrada: entrada.id,
    })
  }
)

const sliceDeleteConfigPtMonMedidor = createSlice({
  name: "DELETE_CONFIG",
  initialState,
  reducers: {
      actionResetDeleteConfigPtMonMedidor: (state) => {
      state.status = ""
    }
  },
  extraReducers: {
      [actionDeleteConfigPtMonMedidor.pending]: (state) => {
      state.status = "loading"
    },
      [actionDeleteConfigPtMonMedidor.fulfilled]: (state, {payload}) => {
      state.status = "success"
      state.data = payload
    },
      [actionDeleteConfigPtMonMedidor.rejected]: (state, err) => {
      console.log(err)
      state.status = "error"
    },
  }
})

export default sliceDeleteConfigPtMonMedidor.reducer
export const { actionResetDeleteConfigPtMonMedidor } = sliceDeleteConfigPtMonMedidor.actions